export default {
	getItem: (state) => (processId) => state.downloads.find((download) => download.process_id === processId),
	getReportByProcessId: (state) => (processId) => state.downloads.find((download) => download.id === processId),
	getFiles: (state) => state.files,
};
